import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Question } from 'src/app/models/question.model';
import { Test } from 'src/app/models/test.model';
import { fromQuestion } from 'src/app/reducers/question.reducer';
import { fromTest } from 'src/app/reducers/test.reducer';
import { QuestionService } from 'src/app/services/question.service';

@Component({
  selector: 'ct-ko-level-time',
  templateUrl: './ko-level-time.component.html',
  styleUrls: ['./ko-level-time.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KoLevelTimeComponent implements OnInit {

  @Input() colors: any;

  public test$: Observable<Test>;
  public question$: Observable<Question>;

  public currentTest: Test;
  public currentQuestion: Question;
  public koLevelTimeAnimation: any;

  constructor(
    private questionService: QuestionService,
    private store: Store,
    private router: Router,
  ) {
    this.koLevelTimeAnimation = { path: 'assets/animations/reloj_turquesa.json' };
  }

  ngOnInit(): void {
    this.test$ = this.store.pipe(select(fromTest.selectTestState));
    this.question$ = this.store.pipe(select(fromQuestion.selectQuestionState));

    this.test$.subscribe(test => {
      this.currentTest = test;
    });

    this.question$.subscribe(question => {
      this.currentQuestion = question;
    });
  }

  public returnHome() {
    this.router.navigate(['candidate/home/' + this.currentTest.invitation.token]);
  }

}
